(function () {
  'use strict';

  /*jshint -W030 */
  var mapping = {
    'required': 'ng-required',
    'minlength': 'ng-minlength',
    'maxlength': 'ng-maxlength',
    'minLength': 'ng-minlength',
    'maxLength': 'ng-maxlength',
    'min': 'min',
    'max': 'max',
    'pattern': 'pattern',
    'type': 'type'
  };

  var controller = ['$scope', '$element', '$attrs', '$http', '$q', '$compile',
    function ($scope, $element, $attrs, $http, $q, $compile) {

      var validationRule = $attrs.validationRule || 'validationRule';

      this.getValidationRule = function () {
        var deferred = $q.defer();
        if ($scope[validationRule]) {
          deferred.resolve($scope[validationRule]);
        } else {
          var url = $attrs.validationRule;
          console.log('getting validation rules remotely from', validationRule);
          $http.get(validationRule).then(function (resp) {
            deferred.resolve(resp.data);
          });
        }
        return deferred.promise;
      };

      this.injectValidationRule = function (formRules) {
        var form = $element[0];
        var modelName = $attrs.uteFormFor;
        for (var elName in formRules) {
          var str = 'input[name=VAL], ' +
            'select[name=VAL], ' +
            'textarea[name=VAL]';
          var selectorStr = str.replace(/VAL/g, '"' + elName + '"');
          var formEls = form.querySelectorAll(selectorStr);
          var elRules = formRules[elName];

          for (var i = 0; i < formEls.length; i++) {
            var el = formEls[i];
            if (el.getAttribute('ng-model')) {
              console.log('ng-model already defined, skipping', el);
            } else {
              el.setAttribute('ng-model', modelName + '.' + elName);
              elRules.required = elRules.required || 'true';
              for (var rule in elRules) {
                var attrKey = mapping[rule],
                  attrVal = elRules[rule];
                if (el.getAttribute(attrKey)) {
                  console.log(attrKey, 'is already defined. skipping', el);
                } else {
                  if (attrVal) {
                    if (typeof attrVal == 'object') {
                      attrVal = attrVal.value;
                    }
                    el.setAttribute(attrKey, attrVal);
                  }
                }
              }
              $compile(el)($scope);
            }
          } // for (formEls)

        } // for (elName in rules)
      }; // function

      this.injectErrorMessages = function (formRules) {
        var formName = $element[0].getAttribute('name');
        for (var elName in formRules) {
          var msgObj = {};
          var generalMsg = formRules[elName].message;
          generalMsg && (msgObj.general = generalMsg);
          for (var key in formRules[elName]) {
            var rule = formRules[elName][key];
            if (typeof rule == 'object' && rule.message) {
              msgObj[key] = rule.message;
            }
          }
          if (Object.keys(msgObj).length > 0) {
            $scope[formName][elName].message = msgObj;
          }
        }
      };
    }
  ];

  angular.module('ute.ui')

    .directive('uteFormFor', function () {
      return {
        controller: controller,
        link: function (scope, element, attrs, ctrl) {
          var form = element[0];
          var formName = form.getAttribute('name');
          if (!formName || form.tagName !== 'FORM') {
            return false;
          }
          form.setAttribute('novalidate', '');

          ctrl.getValidationRule().then(function (formRules) {
            ctrl.injectValidationRule(formRules);
            return formRules;
          }).then(function (formRules) {
            ctrl.injectErrorMessages(formRules);
          });
        }
      };
    });

})();
